export const EnumPasswordStrength = {
    Weak: 'weak',
    Medium: 'medium',
    Strong: 'strong',
}

export const PublicPages = Object.freeze([
    '/',
    '/forgot-password',
    '/reset-password',
    '/corporation-selection',
    '/rhdigital/corporation-selection',
    '/two-factor',
    '/rhdigital'
])

export const languages = [
    {
        code: "en-US",
        label: "English",
        flag: "/images/static/flags/usa.svg",
        alt: "USA"
    },
    {
        code: "es-ES",
        label: "Español",
        flag: "/images/static/flags/spain.svg",
        alt: "España"
    },
    {
        code: "pt-BR",
        label: "Português",
        flag: "/images/static/flags/brasil.svg",
        alt: "Brasil"
    }
]

export const FormLayout = {
    "Check": 2,
    "Reply": 3
}
export const ClientAccessColor = {
    Normal: "#E8F5E9",      // verde claro
    Warning: "#FFF3E0",     // laranja claro
    Blocked: "#FFEBEE",     // vermelho claro
    Suspended: "#E3F2FD"    // azul claro
};

export const ConcentratorStep = {
    "Details": 1,
    "Configuration": 2
}

export const ContractStep = {
    "Contract": 1,
    "Services": 2
}

export const CustomerStep = {
    "Invoicing": 1,
    "Invoices": 2,
    "Equipment": 3,
    "Support": 4,
    "LastLogin": 5
}

export const TicketState = {
    "Waiting": 1,
    "Calling": 2,
    "InService": 3,
    "Finished": 4,
    "Canceled": 5
}


export const ColumnTable = {
    actions: {
        width: "30px",
        smallScreenWidth: "20px",
    },
    name: {
        width: "130px",
        maxChars: 49,
        smallScreenWidth: "100px",
        smallScreenMaxChars: 25
    },
    default: {
        width: "30px",
        maxChars: 50,
        smallScreenWidth: "60px",
        smallScreenMaxChars: 14
    }
}

export const MenuConfig = [
    {
        route: '/dashboard/contracts',
        i18nKey: 'components.dashboard.contracts.pageTitle',
        url: "auth.api.hliberty.net/dashboard/contracts/List"
    },
    {
        route: '/contracts/contract-list',
        i18nKey: 'components.settings.permissionManagement.menuList.Contracts',
        url: "contract.api.hliberty.net/api/contract/GET"
    },
    {
        route: '/contracts/connections',
        i18nKey: 'components.contracts.connection.pageTitle',
        url: "contract.api.hliberty.net/api/contract/GET"
    },
    {
        route: '/products',
        i18nKey: 'components.contracts.product.pageTitle',
        url: "contract.api.hliberty.net/api/contract/GET"
    },
    {
        route: '/settings/users',
        i18nKey: 'components.settings.permissionManagement.menuList.Users',
        url: "auth.api.hliberty.net/user/List"
    },
    {
        route: '/settings/permission-management',
        i18nKey: 'components.settings.permissionManagement.menuList.Permission Management',
        url: "auth.api.hliberty.net/permissionManagement/List"
    },
    {
        route: '/isp/manufacturer',
        i18nKey: 'components.settings.permissionManagement.menuList.Manufacturer',
        url: 'isp.api.hliberty.net/api/radius/manufacturer/GET'
    },
    {
        route: '/isp/attribute',
        i18nKey: 'components.settings.permissionManagement.menuList.Attribute',
        url: 'isp.api.hliberty.net/api/radius/attribute/GET'
    },
    {
        route: '/isp/layouts',
        i18nKey: 'components.settings.permissionManagement.menuList.AttributesLayout',
        url: 'isp.api.hliberty.net/api/radius/layout/GET'
    },
    {
        route: '/isp/pops',
        i18nKey: 'components.settings.permissionManagement.menuList.POP',
        url: 'isp.api.hliberty.net/api/pop/GET'
    },
    {
        route: '/isp/pools',
        i18nKey: 'components.settings.permissionManagement.menuList.Pool',
        url: 'isp.api.hliberty.net/api/radius/pool/GET'
    },
    {
        route: '/isp/concentrators',
        i18nKey: 'components.settings.permissionManagement.menuList.Nas',
        url: 'isp.api.hliberty.net/api/radius/nas/GET'
    },
    {
        route: '/corporation-selection',
        i18nKey: 'components.settings.index.changeCorporation',
        url: 'auth.api.hliberty.net/dashboard/contracts/List'
    },
    {
        route: '/service-types',
        i18nKey: 'Totem',
        url: 'auth.api.hliberty.net/totem/serviceTypes/List'
    },
]

export const PagesPermittedAccess = [
    '/manageFavorites',
    '/my-profile'
]

export const icons = [
    "mdi-star",
    "mdi-home",
    "mdi-view-dashboard",
    "mdi-file-document-outline",
    "mdi-account",
    "mdi-package-variant",
    "mdi-sitemap",
    "mdi-earth",
    "mdi-factory",
    "mdi-account-lock",
    "mdi-account-cog",
    "mdi-domain",
    "mdi-cog",
    "mdi-cog-outline",
    "mdi-security",
    "mdi-shield-lock",
    "mdi-chart-line",
    "mdi-chart-bar",
    "mdi-database",
    "mdi-server",
    "mdi-cloud",
    "mdi-clipboard-list",
    "mdi-tag",
    "mdi-wrench",
    "mdi-cash-multiple",
    "mdi-forum"
];
